import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class NonSalesCategoryService {
  constructor(private ws: PostmethodService) { }

  categoryCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "nonSalesCategoryMaster");
  }
}
